export const enUS = {
  panelTitle: "Advisor Panel",
  managerPanelTitle: "Manager Panel",
  rankingSectionTitle: "Product ranking by market",
  rankingPreviewShow: "View product rankings by market",
  rankingPreviewHide: "Hide product rankings by market",
  rankingPreviewLoadError: "Could not load rankings from the server.",
  rankingPreviewNotConfigured: "No criterion defined.",
  rankingPreviewEditedMeta: "Last edited: {name} · {date}",
  rankingEditForbidden: "Only managers can change rankings. Use the Manager panel.",
  rankingViewProperties: "View ranking properties",
  rankingHideProperties: "Hide ranking properties",
  rankingPropertiesModalTitle: "Properties — {market}",
  rankingPropertiesLoadError: "Could not load ranking properties.",
  rankingPropertiesEmpty: "No properties available for this market.",
  rankingPropertiesClickHint:
    "Click a property or value to build your criterion in the field below.",
  rankingPropertiesExpandModal: "Expand",
  rankingPropertyHigher: "higher",
  rankingPropertyLower: "lower",
  rankingPropertyFilterGt: "greater than…",
  rankingPropertyFilterLt: "less than…",
  rankingPropertyFilterValuePlaceholder: "Value",
  rankingPropertyFilterApply: "Insert",
  rankingPropertyFilterCancel: "Cancel",
  rankingPropertyFilterInvalidValue: "Enter a valid number.",
  rankingPropertyYes: "yes",
  rankingPropertyNo: "no",
  rankingChatPlaceholder: "E.g. highest return, lowest liquidity… (use properties above)",
  chatMessageSendError: "Could not send your message. Please try again.",
  opportunitiesOnManagerPanel:
    "Opportunities and creating new objectives are on the Manager panel. Use the tab above to switch.",
  clientsOverview: "Clients Overview",
  VolumeUnderCustody: "Volume Under Custody",
  opportunities: 'Opportunities',
  objectiveDraftModalTitle: "New objective",
  objectiveDraftReviewTitle: "Review draft",
  objectiveDraftIntro:
    "Describe the strategy in plain language. We will generate a draft: the model proposes an interpretation and a read-only query. You can refine the text and regenerate, or confirm to save.",
  objectivePromptLabel: "Strategy (prompt)",
  objectivePromptHelper: "Main text the model uses to understand the objective and estimate impact. Clearer prompts yield better drafts.",
  objectiveReportTitleLabel: "Report name (optional)",
  objectiveCardStrategyLabel: "Strategy",
  objectiveValidityLabel: "Validity (days)",
  objectiveValiditySuffix: "days",
  objectiveGenerateDraftButton: "Generate draft",
  objectiveReviewHeading: "Draft review (nothing saved yet)",
  objectiveExpiresHint: "This draft expires at",
  objectiveInterpretationHeading: "Model interpretation",
  objectiveCypherHeading: "Generated query (read-only)",
  objectiveImpactedPreviewHeading: "Impact preview",
  objectiveImpactedCount: "Estimated row count",
  objectiveWarningsHeading: "Warnings",
  objectiveStrategyAdjustLabel: "Adjust strategy text and regenerate",
  objectiveRegenerateButton: "Regenerate draft",
  objectiveCommitButton: "Confirm and save objective",
  objectiveBackToFormButton: "Back to form",
  objectivePreviewEmpty: "No preview rows.",
  objectiveDraftCannotCommit:
    "The query was not validated. Adjust the strategy or regenerate the draft before confirming.",
  objectiveCommitSuccess: "Objective created successfully.",
  objectiveMonitoringBadge: "Monitoring",
  objectiveSeeByPortfolio: "View by portfolio",
  objectiveHidePortfolio: "Hide portfolios",
  objectiveMonitorAction: "Monitor",
  objectiveMonitorCollapse: "Hide",
  objectiveMonitoringMeta: "{portfolioCount} portfolios · {movementCount} movements",
  objectiveMonitoringSummary: "Summary",
  objectiveMonitoringPortfolioCol: "Portfolio",
  objectiveMonitoringAdvisorCol: "Advisor",
  objectiveMonitoringAmountCol: "Net amount",
  objectiveMonitoringOpportunityTotalCol: "Opportunity value (See clients)",
  objectiveMonitoringPercentDoneCol: "Percent done",
  objectiveMonitoringNA: "N/A",
  objectiveMonitoringSortHintDesc: "Sorted: highest % done first",
  objectiveMonitoringSortHintAsc: "Sorted: lowest % done first",
  objectiveMonitoringSortToggleAria: "Toggle sort order for percent done",
  objectiveMonitoringNoAdvisor: "No advisor",
  objectiveMonitoringGroupModePortfolio: "By portfolio",
  objectiveMonitoringGroupModeAdvisor: "By advisor",
  objectiveMonitoringGroupModeAria: "Switch between portfolio and advisor aggregation",
  objectiveMonitoringEmpty:
    "No portfolio monitoring data for this objective (or no stored movement query).",
  objectiveMonitoringRollupsHint:
    "Load portfolio rollups once to see movements for this and other monitored objectives.",
  welcomeText1: "Welcome back",
  todayIs: "Today is",
  itIsTime: "It is",
  seeMore: "See more",
  contextMessage: "Contextualized",
  commitments: "Commitments",
  nextContributionPerClient: "Próximos vencimentos e aportes de clientes",
};